import { Map } from "immutable";

// This is a factory function (also called a higher-order function)
function chainablePropType(isRequired) {
	// The factory returns a custom prop type
	return (props, propName) => {
		const prop = props[propName];

		if (prop == null) {
			// Prop is missing
			if (isRequired) {
				throw new Error(`Missing ${propName}`);
			}
			// Prop is optional. Do nothing.
		} else {
			// Put your validation logic here...
			const isValid = Map.isMap(prop) || typeof prop === "string";

			if (!isValid) {
				return new Error(`Expected ${propName} to be a string or Immutable Map.`);
			}
		}

		// assume all ok
		return null;
	};
}

// Using the factory, create two different versions of your prop type
const momentChecker = chainablePropType(false);
momentChecker.isRequired = chainablePropType(true);

export default momentChecker;
